var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0c-4.41867,0 -8,3.58133 -8,8c0,4.41867 3.58133,8 8,8c4.41867,0 8,-3.58133 8,-8c0,-4.41867 -3.58133,-8 -8,-8zM8.44444,5.33333h-0.88889c-0.24533,0 -0.44444,-0.19911 -0.44444,-0.44444v-0.88889c0,-0.24533 0.19911,-0.44444 0.44444,-0.44444h0.88889c0.24533,0 0.44444,0.19911 0.44444,0.44444v0.88889c0,0.24533 -0.19911,0.44444 -0.44444,0.44444zM8.44444,12.44444h-0.88889c-0.24533,0 -0.44444,-0.19911 -0.44444,-0.44444v-4.44444c0,-0.24533 0.19911,-0.44444 0.44444,-0.44444h0.88889c0.24533,0 0.44444,0.19911 0.44444,0.44444v4.44444c0,0.24533 -0.19911,0.44444 -0.44444,0.44444z",
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(160, 160, 160)"
    },
    vectorEffect: "non-scaling-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1643812500272167",
    d: "M8,0c-4.41867,0 -8,3.58133 -8,8c0,4.41867 3.58133,8 8,8c4.41867,0 8,-3.58133 8,-8c0,-4.41867 -3.58133,-8 -8,-8zM8.44444,5.33333h-0.88889c-0.24533,0 -0.44444,-0.19911 -0.44444,-0.44444v-0.88889c0,-0.24533 0.19911,-0.44444 0.44444,-0.44444h0.88889c0.24533,0 0.44444,0.19911 0.44444,0.44444v0.88889c0,0.24533 -0.19911,0.44444 -0.44444,0.44444zM8.44444,12.44444h-0.88889c-0.24533,0 -0.44444,-0.19911 -0.44444,-0.44444v-4.44444c0,-0.24533 0.19911,-0.44444 0.44444,-0.44444h0.88889c0.24533,0 0.44444,0.19911 0.44444,0.44444v4.44444c0,0.24533 -0.19911,0.44444 -0.44444,0.44444z",
    vectorEffect: "non-scaling-stroke"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.492bf26da3bdbcd81a227ac0b6fd418c.svg";
export { ForwardRef as ReactComponent };